/* DNNAVOVERFLOW — re-run <overflow-list>'s own reflow once the web fonts have swapped in.
   Horizon measures the nav once, early. Its ResizeObserver watches the CONTAINER, but what
   changes later is the ITEM widths: the self-hosted fonts load with font-display:swap, the
   labels get wider, and the row overflows a container that never resized — so nothing
   re-measures and at 1280px three menu items sit off the right edge with the "More" button
   never appearing. Toggling `disabled` is the component's own public way to force a reflow
   (see attributeChangedCallback in assets/overflow-list.js). No layout is overridden.

   DNMENUUNSTICK (8 Sep 2026) — same root cause, worse symptom: the header latches into
   hamburger mode on desktop and never recovers. setHeaderMenuStyle(), inlined in
   theme.liquid, sets data-menu-style='drawer' whenever <overflow-list> carries
   minimum-reached. That can trip for a single frame during load — the font swap widens the
   labels while the 13-item nav is already at the edge of fitting. Once it flips, CSS applies
   .header-menu{display:none}, and a display:none overflow-list measures zero forever, so it
   can never report minimumReached:false. Horizon's own header.js acknowledges this in
   #updateMenuVisibility but only clears the latch in the `else` branch — the branch that can
   no longer be reached. Net effect: one bad frame during load costs you the desktop menu
   until a reload. unstick() clears the latch and lets the component re-measure. It is
   bounded per viewport width, so a nav that genuinely does not fit still gets the drawer. */
(function () {
  var RESET_MS = 200;   /* the component needs a real tick to reset and re-measure; a
                           requestAnimationFrame gap (~16ms) was tried and is TOO FAST */
  var DESKTOP = '(min-width: 990px)';
  var MAX_PER_WIDTH = 2; /* two corrections per width; a third means it really does not fit */
  var tries = 0;
  var attempts = {};

  function poke(ol) {
    if (ol.getAttribute('disabled') === 'true') return;
    ol.setAttribute('disabled', 'true');
    setTimeout(function () { ol.removeAttribute('disabled'); }, RESET_MS);
  }

  /* DNNAVWRAP (23 Sep 2026) — the list does NOT spill past its right edge when it breaks.
     The component's shadow <ul> is `flex-wrap: wrap` with an inline `height` pinned to one
     row, so an un-measured nav wraps onto a second row that simply overflows that height.
     Every child's right edge still sits inside the container, so a right-edge test reads
     "fits" and never pokes — which is how the 13-item nav ends up on two lines just above
     the 990px breakpoint. Row count is the honest signal: more than one distinct top among
     the visible children means it wrapped. */
  function overflowing(ol) {
    var box = ol.getBoundingClientRect();
    var edge = box.right;
    if (!edge || !box.width) return false;               /* display:none — nothing to read */
    var kids = ol.children;
    var firstTop = null;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].getAttribute('slot')) continue;      /* already parked in more/overflow */
      var r = kids[i].getBoundingClientRect();
      if (!r.width && !r.height) continue;             /* not rendered */
      if (r.right > edge + 1) return true;             /* spilled past the right edge */
      if (firstTop === null) firstTop = r.top;
      else if (Math.abs(r.top - firstTop) > 2) return true;  /* wrapped onto a second row */
    }
    return false;
  }

  /* Clear a stuck drawer latch on desktop. Never touches real touch devices, never fights an
     open drawer, and stops correcting at a width where the menu honestly cannot fit. */
  function unstick() {
    var h = document.getElementById('header-component');
    if (!h) return;
    if (h.dataset.menuStyle !== 'drawer') return;
    if ('ontouchstart' in window && navigator.maxTouchPoints > 0) return;
    if (!window.matchMedia(DESKTOP).matches) return;
    if (h.querySelector('details[open]')) return;        /* drawer is open — leave it alone */

    var w = window.innerWidth;
    attempts[w] = (attempts[w] || 0) + 1;
    if (attempts[w] > MAX_PER_WIDTH) return;

    var ol = h.querySelector('overflow-list');
    if (!ol) return;
    ol.removeAttribute('minimum-reached');
    h.dataset.menuStyle = 'menu';                        /* makes the list measurable again */
    poke(ol);
  }

  /* Only act when the nav is genuinely broken, then verify and retry a bounded number of
     times. Self-correcting, so it does not depend on winning a race with font loading. */
  function check() {
    if (tries++ > 6) return;
    unstick();
    var lists = document.querySelectorAll('overflow-list');
    var acted = false;
    Array.prototype.forEach.call(lists, function (ol) {
      if (overflowing(ol)) { poke(ol); acted = true; }
    });
    if (acted) setTimeout(check, RESET_MS + 400);
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
    setTimeout(check, 60);
  });
  window.addEventListener('load', function () { setTimeout(check, 300); });

  /* A resize across the breakpoint is the other way people land in the stuck state. */
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { tries = 0; check(); }, 250);
  });

  setTimeout(check, 1500);
  setTimeout(check, 3000);
})();
